import { MenuTipDollarSettingsBuilder } from "./menu.dollar.builder";

export class MenuTipDollarSettings {
  public readonly minimum: number;
  public readonly one: number;
  public readonly two: number;
  public readonly three: number;
  constructor(builder: MenuTipDollarSettingsBuilder) {
    this.minimum = builder.minimum;
    this.one = builder.one;
    this.two = builder.two;
    this.three = builder.three;
  }
}
